export default "__VITE_ASSET__84955713__"